import { AuthService } from '@spartacus/core';
import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { LoggerService, tryNormalizeHttpError } from "@spartacus/core";
import { catchError, map, of, switchMap, withLatestFrom, concatMap, forkJoin, mergeMap, EMPTY, from, } from "rxjs";
import { ApiService } from "../../../../SGRE-shared/services/api.service";
import * as carouselAction from '../action/fetch_carousel_image.action';
import { HomePageEffectsService } from './homepage-effects.service';
import * as categoriesAction from '../action/fetch-categories.action';
import * as topProductsAction from '../action/fetch-topFetaureProduct.action';
import * as topProductPriceAction from '../action/fetch-topFeatureProductPrice.action';
import { itemState } from "../homepage.state";
import { TopProductInfo } from "../../models/homepage.model";
import { CustomProduct } from '../../../product-list-page/models/custom-product.model';
import { delay } from 'rxjs/operators';
@Injectable()
export class HomePageEffects {

  protected logger = inject(LoggerService);

  constructor(
    private actions: Actions,
    private apiService: ApiService,
    private homePageEffectsService: HomePageEffectsService,
    private authService: AuthService
  ) { }


  fetchCarouselImages$ = createEffect(() =>
    this.actions.pipe(
      ofType(carouselAction.fetchCarouselImagesAction),
      switchMap((action) =>
        this.homePageEffectsService.getCarouselImages(action.bannersImages).pipe(
          map((data: string[]) => {
            return carouselAction.fetchCarouselImagesActionSuccess({ imageList: data });
          }),
          catchError((error) => of(carouselAction.fetchCarouselImagesActionFail({ payload: tryNormalizeHttpError(error, this.logger) })))
        )
      )
    )
  );

  fetchCategoriesList$ = createEffect(() =>
    this.actions.pipe(
      ofType(categoriesAction.fetchCategoriesAction),
      switchMap((action) =>
        this.apiService.getHomePageCategories(action.paramsObject).pipe(
          map((response: { categories: itemState[] }) => {
            const filteredData: itemState[] = this.homePageEffectsService.filterCategories(response.categories);
            return categoriesAction.fetchCategoriesActionSuccess({ categories: filteredData });
          }),
          catchError((error) => of(categoriesAction.fetchCategoriesActionFail({ payload: tryNormalizeHttpError(error, this.logger) }))
          )
        )
      )
    )
  );

  fetchTopProductsList$ = createEffect(() =>
    this.actions.pipe(
      ofType(topProductsAction.fetchTopProductsAction),
      switchMap((action) =>
        this.apiService.getTopFeaturedProductList(action.currentPage, action.fields, action.pageSize)
          .pipe(
            map((data: TopProductInfo) => {
              let products = (data.products || []);
              return topProductsAction.fetchTopProductsActionSuccess({ products });
            }),
            catchError((error) => of(topProductsAction.fetchTopProductsActionFail({ payload: tryNormalizeHttpError(error, this.logger) })))
          )
      ),
    )
  );

  fetchPricesAfterProducts$ = createEffect(() =>
    this.actions.pipe(
      ofType(topProductsAction.fetchTopProductsActionSuccess),
      withLatestFrom(this.authService.isUserLoggedIn()),
      concatMap(([action, isLoggedIn]) => {
        let products = action.products || [];
        const productsToLoadPrice = products.filter(
          p => !p.isCachePrice
        );
        const productCodes = productsToLoadPrice.map(p => p.code);

        if (isLoggedIn && productCodes.length > 0) {
          console.log("productCodes", productCodes);
          return of(topProductPriceAction.fetchProductPriceAction({ productCodes }));
        }
        return EMPTY;
      }),
      delay(100) // Add artificial delay of 100ms
    )
  );

  fetchTopProductsPrice$ = createEffect(() =>
    this.actions.pipe(
      ofType(topProductPriceAction.fetchProductPriceAction),
      mergeMap(({ productCodes }) => {
        const batches = [];
        for (let i = 0; i < productCodes.length; i += 6) {
          batches.push(productCodes.slice(i, i + 6));
        }
        if (!batches.length) {
          return EMPTY;
        }
        return forkJoin(
          batches.map(batch =>
            this.apiService.getTopProductsPriceList(batch).pipe(
              map((response: any) => {
                const priceList: CustomProduct[] = response?.body?.priceItems || [];
                return priceList.map((priceObj) => {
                  if (priceObj.message && priceObj.message !== 8 && priceObj.message !== 4 && priceObj.message !== 9) {
                    return topProductPriceAction.fetchProductPriceActionFail({
                      error: priceObj.message || 'Price fetch failed',
                      productCodes: [priceObj.code]
                    });
                  } else {
                    return topProductPriceAction.fetchProductPriceActionSuccess({
                      priceItems: [{
                        ...priceObj,
                        code: priceObj.code,
                        quotationFlag: priceObj.quotationFlag,
                        obsoleteFlag: priceObj.obsoleteFlag,
                        discountPriceData: priceObj.discountPriceData,
                      }]
                    });
                  }
                });
              }),
              catchError((error) =>
                of(
                  batch.map(code =>
                    topProductPriceAction.fetchProductPriceActionFail({
                      error: JSON.stringify(tryNormalizeHttpError(error, this.logger)),
                      productCodes: [code]
                    })
                  )
                )
              )
            )
          )
        ).pipe(
          mergeMap((actionsArrays) => from(actionsArrays.flat()))
        );
      })
    )
  );
}
